// import React, { useState, useRef, useMemo, useEffect } from "react";
// import {
//   Card,
//   CardContent,
//   List,
//   ListItem,
//   Divider,
//   IconButton,
//   CircularProgress,
//   Box,
// } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { getFoulWords, removeFoulWord } from "../../../redux/slices/foulWordsSlice";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import EditFoulWordDialog from "./EditFoulWordDialog";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// const FoulWordsList = () => {
//   const dispatch = useDispatch();
//   const scrollRef = useRef(null);

//   const { foulWords: words, loading, page, totalCount } = useSelector(
//     (state) => state.foulWordsDetails
//   );
//   const isInitialLoading = loading && page === 1;

//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [selectedWord, setSelectedWord] = useState(null);

//   const handleEditClick = (word) => {
//     setSelectedWord(word);
//     setEditDialogOpen(true);
//   };

//   const handleDelete = (id) => {
//     dispatch(removeFoulWord(id));
//   };

//   const loadMore = () => {
//     const scrollContainer = scrollRef.current;
//     if (scrollContainer) {
//       const prevScrollHeight = scrollContainer.scrollHeight;
//       dispatch(getFoulWords({ page: page + 1 })).then(() => {
//         // Maintain scroll position
//         requestAnimationFrame(() => {
//           const newScrollHeight = scrollContainer.scrollHeight;
//           scrollContainer.scrollTop += newScrollHeight - prevScrollHeight;
//         });
//       });
//     } else {
//       dispatch(getFoulWords({ page: page + 1 }));
//     }
//   };

//   const renderedWordList = useMemo(() => (
//     <List dense disablePadding>
//       {words && words.length > 0 ? (
//         words.map((word, index) => (
//           <React.Fragment key={word.id || index}>
//             <ListItem
//               sx={{ fontSize: "0.95rem", fontWeight: 500 }}
//               secondaryAction={
//                 <MDBox display="flex" gap={1} mr={3}>
//                   <IconButton edge="end" onClick={() => handleEditClick(word)}>
//                     <EditIcon />
//                   </IconButton>
//                   <IconButton edge="end" onClick={() => handleDelete(word.id)}>
//                     <DeleteIcon />
//                   </IconButton>
//                 </MDBox>
//               }
//             >
//               {word.foulWord}
//             </ListItem>
//             {index !== words.length - 1 && <Divider />}
//           </React.Fragment>
//         ))
//       ) : (
//         <MDTypography variant="body2" color="textSecondary">
//           No foul words available.
//         </MDTypography>
//       )}
//     </List>
//   ), [words]);

//   return (
//     <>
//       <Card variant="outlined">
//         {isInitialLoading ? (
//           <MDBox
//             display="flex"
//             justifyContent="center"
//             alignItems="center"
//             width="100%"
//             height="200px"
//           >
//             <CircularProgress sx={{ color: "orange" }} size={48} />
//           </MDBox>
//         ) : (
//           <CardContent>
//             <Box
//               mb={2}
//               py={1.5}
//               boxShadow="0 3px 4px rgba(0, 0, 0, 0.04)"
//             >
//               <MDTypography
//                 variant="h5"
//                 fontWeight="600"
//                 color="text.primary"
//               >
//                 All Foul Words
//               </MDTypography>
//             </Box>

//             <Box
//               ref={scrollRef}
//               sx={{
//                 height: "70vh",
//                 overflowY: "auto",
//                 overflowX: "hidden",
//               }}
//             >
//               {renderedWordList}

//               {words.length < totalCount && (
//                 <Box
//                   mt={2}
//                   display="flex"
//                   justifyContent="center"
//                   alignItems="center"
//                   onClick={!loading ? loadMore : undefined}
//                   sx={{
//                     cursor: loading ? "default" : "pointer",
//                     fontSize: "0.95rem",
//                     color: "#ff6d00", // orange text
//                     transition: "opacity 0.2s",
//                     "&:hover": {
//                       opacity: 0.8,
//                     },
//                   }}
//                 >
//                   {loading ? (
//                     <CircularProgress size={18} sx={{ color: "#ff6d00" }} />
//                   ) : (
//                     <>
//                       Load More <KeyboardArrowDownIcon fontSize="small" />
//                     </>
//                   )}
//                 </Box>
//               )}
//             </Box>
//           </CardContent>
//         )}
//       </Card>

//       <EditFoulWordDialog
//         open={editDialogOpen}
//         onClose={() => setEditDialogOpen(false)}
//         word={selectedWord}
//       />
//     </>
//   );
// };

// export default FoulWordsList;

import React, { useState, useRef, useMemo } from "react";
import {
  Card,
  CardContent,
  List,
  ListItem,
  Divider,
  Checkbox,
  Box,
  IconButton,
  Button,
  CircularProgress,
  FormControlLabel,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getFoulWords } from "../../../redux/slices/foulWordsSlice";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import EditFoulWordDialog from "./EditFoulWordDialog";
import { deleteFoulWord } from "services/apis";
import Swal from "sweetalert2";

const FoulWordsList = () => {
  const dispatch = useDispatch();
  const scrollRef = useRef(null);

  const { foulWords: words, loading, page, totalCount } = useSelector(
    (state) => state.foulWordsDetails
  );

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedWord, setSelectedWord] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);

  const isInitialLoading = loading && page === 1;

  const handleEditClick = (word) => {
    setSelectedWord(word);
    setEditDialogOpen(true);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = words.map((word) => word.id);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelectOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleDeleteSelected = async () => {

    console.log(selectedIds)
    const res = await deleteFoulWord({ wordIdList: selectedIds })
    if (res.success) {
      dispatch(getFoulWords({ page: 1 }));
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        timer: 1500,
        showConfirmButton: false,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Some Error Occurred.",
      });
    }
    setSelectedIds([]);
  };

  const loadMore = () => {
    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      const prevScrollHeight = scrollContainer.scrollHeight;
      dispatch(getFoulWords({ page: page + 1 })).then(() => {
        requestAnimationFrame(() => {
          const newScrollHeight = scrollContainer.scrollHeight;
          scrollContainer.scrollTop += newScrollHeight - prevScrollHeight;
        });
      });
    } else {
      dispatch(getFoulWords({ page: page + 1 }));
    }
  };

  const renderedWordList = useMemo(() => (
    <List dense disablePadding>
      {words && words.length > 0 ? (
        words.map((word, index) => (
          <React.Fragment key={word.id}>
            <ListItem
              sx={{
                fontSize: "0.95rem",
                fontWeight: 500,
                pl: 0.5,
              }}
              disablePadding
              secondaryAction={
                <IconButton style={{ marginRight: "15px" }} edge="end" onClick={() => handleEditClick(word)}>
                  <EditIcon fontSize="small" />
                </IconButton>
              }
            >
              <Checkbox
                checked={selectedIds.includes(word.id)}
                onChange={() => handleSelectOne(word.id)}
                style={{
                  color: "#ff6d00", // Bright orange
                }}
              />
              {word.foulWord}
            </ListItem>
            {index !== words.length - 1 && <Divider />}
          </React.Fragment>
        ))
      ) : (
        <MDTypography variant="body2" color="textSecondary">
          No foul words available.
        </MDTypography>
      )}
    </List>
  ), [words, selectedIds]);

  return (
    <>
      <Card variant="outlined">
        {isInitialLoading ? (
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="200px"
          >
            <CircularProgress sx={{ color: "orange" }} size={48} />
          </MDBox>
        ) : (
          <CardContent>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
              py={1.5}
              boxShadow="0 3px 4px rgba(0, 0, 0, 0.04)"
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      words.length > 0 &&
                      selectedIds.length === words.length
                    }
                    indeterminate={
                      selectedIds.length > 0 &&
                      selectedIds.length < words.length
                    }
                    onChange={handleSelectAll}
                  />
                }
                label={
                  <MDTypography variant="h6" fontWeight="600" color="text.primary">
                    All Foul Words
                  </MDTypography>
                }
              />

              {selectedIds.length > 0 && (
                <Button
                  variant="outlined"
                  size="small"
                  color="error"
                  onClick={handleDeleteSelected}
                >
                  Delete Selected
                </Button>
              )}
            </Box>

            <Box
              ref={scrollRef}
              sx={{
                height: "70vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {renderedWordList}

              {words.length < totalCount && (
                <Box
                  mt={2}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  onClick={!loading ? loadMore : undefined}
                  sx={{
                    cursor: loading ? "default" : "pointer",
                    fontSize: "0.95rem",
                    color: "#ff6d00",
                    transition: "opacity 0.2s",
                    "&:hover": {
                      opacity: 0.8,
                    },
                  }}
                >
                  {loading ? (
                    <CircularProgress size={18} sx={{ color: "#ff6d00" }} />
                  ) : (
                    <>
                      Load More <KeyboardArrowDownIcon fontSize="small" />
                    </>
                  )}
                </Box>
              )}
            </Box>
          </CardContent>
        )}
      </Card>

      <EditFoulWordDialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        word={selectedWord}
      />
    </>
  );
};

export default FoulWordsList;

